import { render, staticRenderFns } from "./ShopSectionNav.vue?vue&type=template&id=4e42ad2c&scoped=true&"
import script from "./ShopSectionNav.vue?vue&type=script&lang=js&"
export * from "./ShopSectionNav.vue?vue&type=script&lang=js&"
import style0 from "./ShopSectionNav.vue?vue&type=style&index=0&id=4e42ad2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e42ad2c",
  null
  
)

export default component.exports